import * as React from 'react'
import { useTranslation } from 'react-i18next';
import {
    DefaultButton,
    Modal,
    PrimaryButton,
    SearchBox,
    Checkbox,
    Dropdown
} from '@fluentui/react';
import { Selection } from '@fluentui/react/lib/DetailsList';
import * as Api from "../../../api/src"
import ModalHeader from '../../../control/modalHeader';

const MatrixItemsApi = new Api.MatrixItemsApi();
let _selection: Selection | undefined = new Selection({ selectionMode: 1 });

export interface ModalVendorProps {
    IsOpen: boolean,
    onCloseModal: () => void;
    onSaveClick: () => void;
    Item: number
}
const ModalVendor = ({ IsOpen, onCloseModal, onSaveClick, Item }: ModalVendorProps) => {
    const { t } = useTranslation();
    const [isShow, SetIsShow] = React.useState(false);
    const [listModules, SetListModules] = React.useState<any[]>([]);
    const [listVendors, SetListVendors] = React.useState<any[]>([]);
    const [searchValue, SetSearchValue] = React.useState<string>('');
    
    React.useEffect(() => {
        if (IsOpen) {
            SetIsShow(IsOpen);
            getData();
        }
    }, [IsOpen]);

    const getData = async () => {
        let data = (await (MatrixItemsApi.apiMatrixItemsMatrixItemIdAddRemoveVendorGet(Item))).data;
        if (data) {
            let modules: any[] = [{ key: -1, text: t("AllModules") }];
            data.Data?.Modules?.forEach(element => {
                modules.push({ key: element.Id, text: element.Name });
            });
            SetListModules(modules);
            let vendors: any[] = [];
            data.Data?.Vendors?.forEach(element => {
                let item = {...element,  modules: [-1], selected: false};
                data.Data?.VendorWithModuleChosens?.forEach(select => {
                    if (select.VendorId === item.Id) {
                        item.selected = true;
                        item.modules = select.ModuleChosenIds || [];
                    }
                })
                /* if (data.Data?.CurrentProductVendor && data.Data?.CurrentProductVendor?.Id === item.Id) {
                    item.selected = true;
                    item.modules = [-1];
                } */
                vendors.push(item);
            });
            SetListVendors(vendors);
        }
    }

    const onClose = () => {
        onCloseModal()
        SetIsShow(false)
    }
    const onSave = async () => {
        let params: Api.AddRemoveMatrixModuleVendorCommmand = {
            "MatrixItemId": Item,
            "VendorWithModuleChosens": []
        }
        let vendors: Api.VendorWithModuleChosen[] = [];
        listVendors.forEach(vendor => {
            if (vendor.selected) {
                vendors.push({
                    "VendorId": vendor.Id,
                    "ModuleChosenIds": vendor.modules
                })
            }
        });
        params.VendorWithModuleChosens = vendors;
        await MatrixItemsApi.apiMatrixItemsMatrixItemIdAddRemoveVendorPatch(Item, params);
        onCloseModal();
        SetIsShow(false);
        onSaveClick();
    }
    const onChange = React.useCallback(
        (ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean): void => {
            //setIsChecked(!!checked);
        },
        [],
    );
    
    return (
        <Modal
            isOpen={isShow}
            isModeless={true}
        >
            <ModalHeader title={t('AddRemoveVendor')} onCloseModal={() => {
                onClose();
            }} />
            <div className={'modal-content'} style={{ width: 700 }}>
                <div>{t('AddRemoveVendorDescription')}</div>
                <br></br>
                <SearchBox placeholder={t("SearchVendor")} value={searchValue} onChange={(e, newValue) => { 
                    SetSearchValue(newValue || ''); }} />
                <br></br>
                <div className="ms-Grid" dir="ltr" >
                    { listVendors.filter(vendor => vendor.Name.match(new RegExp(searchValue, "i"))).map(vendor => { 
                        return (<div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm6" style={{paddingTop: 12}}>
                                <Checkbox label={vendor.Name} checked={vendor.selected} onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) => {
                                    vendor.selected = checked;
                                    SetListVendors([...listVendors])
                                }}/>
                            </div>
                            <div className="label ms-Grid-col ms-sm6">
                                <Dropdown options={listModules} selectedKeys={vendor.modules} multiSelect
                                    disabled={!vendor.selected}
                                    onChange={(e, newValue) => { 
                                        if (newValue) {
                                            if(newValue?.selected) {
                                                if (newValue.key === -1) {
                                                    vendor.modules = [-1];
                                                } else {
                                                    if (vendor.modules.indexOf(-1) >= 0) {
                                                        vendor.modules = [newValue.key];
                                                    } else {
                                                        vendor.modules = [...vendor.modules, newValue.key];
                                                    }
                                                }
                                            } else {
                                                vendor.modules = vendor.modules.filter((k: string | number) => k !== newValue.key)
                                            }
                                        }
                                        SetListVendors([...listVendors])
                                        
                                    }}
                                ></Dropdown>
                            </div>
                        </div>)
                    })
                    }
                </div>
            </div>
            <div className={'modal-footer'}>
                <DefaultButton className={"margin-left-10"} onClick={() => { onClose(); }} >{t("Close")}</DefaultButton>
                <PrimaryButton className={"margin-left-10"} onClick={() => { onSave(); }}>{t("Save")}</PrimaryButton>
            </div>
        </Modal>
    );
}
export default ModalVendor;